export default {
  name: 'notifications-top',
  props: {
    errorMsgGeneral: String,
    errorIsVisible: Boolean
  }
}
